import React, {Fragment, useEffect, useState} from "react";
import {Popover, Transition} from "@headlessui/react";
import {ChevronDownIcon} from "@heroicons/react/20/solid";
import {t} from "i18next";
import {Link} from "react-router-dom";

export const OtherMenu = () => {
    const optionsData = [
        {
            title: t("HEADER.OTHER_MENU.2010_GRANTH.TITLE"),
            description: t("HEADER.OTHER_MENU.2010_GRANTH.DESCRIPTION"),
            icon: "/assets/granth-icon-outlined.svg",
            hoverIcon: "/assets/granth-icon-filled.svg",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/myFolder/joglekar_kulvrutant_2010.pdf",
        },
        {
            title: t("HEADER.OTHER_MENU.PHOTO_GALLERY.TITLE"),
            description: t("HEADER.OTHER_MENU.PHOTO_GALLERY.DESCRIPTION"),
            icon: "/assets/photo-gallery-icon-outlined.svg",
            hoverIcon: "/assets/photo-gallery-icon-filled.svg",
            url: '/photo-gallery'
        },
        {
            title: t("HEADER.OTHER_MENU.BEST_WISHES.TITLE"),
            description: t("HEADER.OTHER_MENU.BEST_WISHES.DESCRIPTION"),
            icon: "/assets/best-wishes-icon-outlined.svg",
            hoverIcon: "/assets/best-wishes-icon-filled.svg",
            url: '/best-wishes'
        },
        {
            title: t("HEADER.OTHER_MENU.REMEMBRANCE_DAY.TITLE"),
            description: t("HEADER.OTHER_MENU.REMEMBRANCE_DAY.DESCRIPTION"),
            icon: "/assets/remembrance-day-icon-outlined.svg",
            hoverIcon: "/assets/remembrance-day-icon-filled.svg",
            url: '/remembrance-day'
        },

        {
            title: t("HEADER.OTHER_MENU.PRIDE.TITLE"),
            description: t("HEADER.OTHER_MENU.PRIDE.DESCRIPTION"),
            icon: "/assets/pride-icon-outlined.svg",
            hoverIcon: "/assets/pride-icon-filled.svg",
            url: '/pride'
        },
        {
            title: t("HEADER.OTHER_MENU.MEMORIES.TITLE"),
            description: t("HEADER.OTHER_MENU.MEMORIES.DESCRIPTION"),
            icon: "/assets/memories-icon-outlined.svg",
            hoverIcon: "/assets/memories-icon-filled.svg",
            url: '/memories'
        },
        {
            title: t("HEADER.OTHER_MENU.ANUROOP_JODIDAR.TITLE"),
            description: t("HEADER.OTHER_MENU.ANUROOP_JODIDAR.DESCRIPTION"),
            icon: "/assets/anuroop-jodidar-icon-outlined.svg",
            hoverIcon: "/assets/anuroop-jodidar-icon-filled.svg",
            url: '/anuroop-jodidar'
        },
        {
            title: t("HEADER.OTHER_MENU.NEWS_EVENTS.TITLE"),
            description: t("HEADER.OTHER_MENU.NEWS_EVENTS.DESCRIPTION"),
            icon: "/assets/news-and-events-icon-outlined.svg",
            hoverIcon: "/assets/news-and-events-icon-filled.svg",
            url: '/new-event'
        },
        {
            title: t("HEADER.OTHER_MENU.HAPPY_TO_SHARE.TITLE"),
            description: t("HEADER.OTHER_MENU.HAPPY_TO_SHARE.DESCRIPTION"),
            icon: "/assets/happy-to-share-icon-outlined.svg",
            hoverIcon: "/assets/happy-to-share-icon-filled.svg",
            url: '/happy-to-share'
        },
        // {
        //     title: t("HEADER.OTHER_MENU.HELP_EACH_OTHER.TITLE"),
        //     icon: (
        //         <LiaHandsHelpingSolid
        //             className="h-full w-auto aspect-square text-gray-600 group-hover:text-white"
        //             aria-hidden="true"
        //         />
        //     ),
        //     url: '/help-each-other'
        // },
    ];

    const [isTouchDevice, setIsTouchDevice] = useState(false);

    const [open, setOpen] = useState(false);
    const [hover, setHover] = useState(false);
    const [hoveredOptionIndex, setHoveredOptionIndex] = useState(null);


    useEffect(() => {
        const checkTouchDevice = () => setIsTouchDevice("ontouchstart" in window || navigator.maxTouchPoints > 0);
        checkTouchDevice();
        window.addEventListener("resize", checkTouchDevice);
        return () => window.removeEventListener("resize", checkTouchDevice);
    }, []);

    return (
        <Popover className="relative flex">
            {({}) => {
                // To prevent the body from scrolling when the popover is open
                document.body.classList.toggle("overflow-y-hidden", open);

                return (
                    <>
                        <button
                            onClick={() => setOpen(!open)}
                            onMouseEnter={() => !isTouchDevice && setHover(true)}
                            onMouseLeave={() => !isTouchDevice && setHover(false)}
                            onBlur={() => setOpen(false)}
                            className={`inline-flex items-center gap-x-1 outline-none`}
                        >
                            <p
                                className="text-[1rem]
                                portrait:sm:text-[0.6rem] portrait:jk:text-[1.15rem]
                                landscape:sm:text-[0.75rem] landscape:jk:text-[1rem]
                                font-custom-medium leading-6 text-gray-900"
                            >
                                {t("HEADER.OTHER_MENU.TITLE")}
                            </p>
                            <ChevronDownIcon
                                className={`h-[1.25vh] w-[1.25vh]
                                    md:h-[2.25vh] md:w-[2.25vh] 
                                    portrait:sm:h-[0.5rem] portrait:sm:w-[0.5rem]
                                    portrait:jk:h-[1rem] portrait:jk:w-[1rem]
                                    landscape:sm:h-[0.9rem] landscape:sm:w-[0.9rem]
                                    ${hover || open ? "rotate-180" : "rotate-0"}
                                    transition-all duration-150 ease-in-out`}
                                aria-hidden="true"
                            />
                        </button>

                        <Transition
                            show={open || hover}
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                        >
                            <Popover.Panel
                                onMouseEnter={() => setOpen(true)}
                                onMouseLeave={() => setOpen(false)}
                                onClick={(e) => e.stopPropagation()}
                                className="absolute left-1/2 z-20 flex w-screen max-w-max -translate-x-1/2 rounded-2xl
                                portrait:jk:mt-[1.25rem] landscape:md:mt-[0.5rem] landscape:jk:mt-[0.75rem]"
                            >
                                <div
                                    className={`flex-auto overflow-hidden shadow-lg bg-white 
                                        portrait:jk:w-[17.5rem] portrait:rounded-xl
                                        landscape:md:w-[15rem] landscape:jk:w-[17.5rem] 
                                        landscape:rounded-2xl ring-2 ring-orange-300/5`}
                                >
                                    {/* Menu Options List */}
                                    <div
                                        className="overflow-y-auto flex flex-col
                                        gap-y-[0.5rem] p-[0.25rem] portrait:jk:h-[15rem]
                                        landscape:md:h-[12.5rem] landscape:jk:h-[15rem]"
                                    >
                                        {optionsData.map((option, index) => (
                                            <Link
                                                key={index}
                                                to={option.url}
                                            >
                                                <div
                                                    className={`group relative flex
                                                        ${hoveredOptionIndex === index && 'bg-gray-200'}
                                                        landscape:md:p-[0.4rem] landscape:jk:p-[0.5rem]
                                                        landscape:md:gap-x-[0.55rem] landscape:jk:gap-x-[0.75rem]
                                                        landscape:md:rounded-xl portrait:jk:rounded-xl
                                                        portrait:jk:p-[0.45rem] portrait:jk:gap-x-[0.65rem]
                                                        transition duration-150 ease-[cubic-bezier(0.215,0.61,0.355,1)]`}
                                                    onMouseEnter={() => setHoveredOptionIndex(index)}
                                                    onMouseLeave={() => setHoveredOptionIndex(null)}
                                                    onTouchStart={() => setHoveredOptionIndex(index)}
                                                    onTouchEnd={() => setHoveredOptionIndex(null)}
                                                >
                                                    <div
                                                        className={`flex items-center justify-center aspect-square
                                                        landscape:md:h-[1.85rem] landscape:jk:h-[2.25rem]
                                                        landscape:md:p-[0.45rem] landscape:jk:p-[0.6rem]
                                                        landscape:md:rounded-lg portrait:jk:rounded-lg
                                                        portrait:jk:h-[2.25rem] portrait:jk:p-[0.6rem]
                                                        ${hoveredOptionIndex === index ? 'bg-orange-400' : 'bg-gray-50'}
                                                        transition duration-150 ease-[cubic-bezier(0.215,0.61,0.355,1)]`}
                                                    >
                                                        <img
                                                            alt={option.title}
                                                            src={hoveredOptionIndex === index ? option.hoverIcon : option.icon}
                                                            className="h-full w-auto aspect-square"
                                                        />
                                                    </div>
                                                    <div
                                                        className={"flex flex-col"}
                                                    >
                                                        <h1
                                                            className="font-custom-semi-bold leading-tight text-gray-900
                                                                landscape:md:text-[0.65rem] landscape:jk:text-[0.8rem]
                                                                portrait:jk:text-[0.8rem]"
                                                        >
                                                            {option.title}
                                                        </h1>
                                                        <p
                                                            className="mt-0.5
                                                                font-custom-regular leading-tight text-gray-700
                                                                landscape:md:text-[0.5rem] landscape:jk:text-[0.65rem]
                                                                portrait:jk:text-[0.65rem]"
                                                        >
                                                            {option.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </Popover.Panel>
                        </Transition>
                    </>
                );
            }}
        </Popover>
    );
};
